import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { fr } from "@/translations/fr";
import { en } from "@/translations/en";
import { ro } from "@/translations/ro";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ro: { translation: ro },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en", "ro"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "vtc_lang",
    },
  });

export default i18n;
